<template>
    <div>
        <!-- Text -->
        <div v-if="type == 'text'">
            <label
            v-show="displayLabel"
            :for="labelToId"
            class="block mb-2"
            :class="(errors && errors.length > 0 ? 'font-bold text-red-600' : 'font-light text-gray-600')"
            v-html="label">
            </label>

            <div class="flex items-center">
                <input
                type="text"
                class="bg-gray-50 text-gray-900 text-sm rounded-lg focus:ring-gray-400 focus:border-gray-400 block w-full p-2.5"
                :class="classSrc + ' ' + (errors && errors.length > 0 ? 'border-2 border-red-500' : 'border border-gray-300')"
                :id="labelToId"
                :placeholder="placeholder"
                v-model="inputValue"
                :disabled="disabled"
                :test-id="testIdValue"
                :maxlength="maxlength"
                >
                <span class="text-xs text-gray-700 cursor-pointer hover:text-gray-800" v-title="tooltip" v-if="tooltip">
                    <i class="fas fa-question-circle"></i> {{$t('composants.sav-input.en_savoir_plus')}}
                </span>
            </div>
            <small v-if="modalHelper" @click="modalHelper(meta)" class="text-blue-600 block text-xs font-light hover:underline mt-2 cursor-pointer">
                <i class="fas fa-circle-question"></i> {{$t('composants.sav-input.ou_trouver_cette_information_?')}}
            </small>
        </div>

        <!-- Password -->
        <div v-if="type == 'password'">
            <label
            v-show="displayLabel"
            :for="labelToId"
            class="block pb-2"
            :class="(errors && errors.length > 0 ? 'font-bold text-red-600' : 'font-light text-gray-600')"
            v-html="label"></label>
            <div class="flex items-center">
                <input
                :test-id="testIdValue"
                :type="displayPassword ? 'text' : 'password'"
                class="bg-gray-50 text-gray-900 text-sm rounded-l-lg focus:ring-gray-100 focus:border-gray-100 block w-full p-2.5"
                :class="classSrc + ' ' + (errors && errors.length > 0 ? 'border-2 border-red-500' : 'border border-gray-300')"
                :id="labelToId"
                :placeholder="placeholder"
                v-model="inputValue"
                :disabled="disabled"
                >
                <button @click="displayPassword = !displayPassword" class="p-2.5 py-3 rounded-r-lg text-xs duration-200 border border-l-0 cursor-pointer bg-gray-50 hover:bg-gray-100">
                    <div v-show="displayPassword">
                        <i class="fas fa-eye"></i>
                    </div>
                    <div v-show="!displayPassword">
                        <i class="fas fa-eye-slash"></i>
                    </div>
                </button>
                <span class="text-xs text-gray-700 cursor-pointer hover:text-gray-800" v-title="tooltip" v-if="tooltip">
                    <i class="fas fa-question-circle"></i> {{$t('composants.sav-input.en_savoir_plus')}}
                </span>
            </div>
        </div>

        <!-- Email -->
        <div v-if="type == 'email'">
            <label
            v-show="displayLabel"
            :for="labelToId"
            class="block pb-2"
            :class="(errors && errors.length > 0 ? 'font-bold text-red-600' : 'font-light text-gray-600')"
            v-html="label"
            ></label>
            <div class="flex items-center">
                <input
                :test-id="testIdValue"
                type="email"
                class="bg-gray-50 text-gray-900 text-sm rounded-lg focus:ring-gray-400 focus:border-gray-400 block w-full p-2.5"
                :class="classSrc + ' ' + (errors && errors.length > 0 ? 'border-2 border-red-500' : 'border border-gray-300')"
                :id="labelToId"
                :placeholder="placeholder"
                v-model="inputValue"
                :disabled="disabled"
                >
                <span class="text-xs text-gray-700 cursor-pointer hover:text-gray-800" v-title="tooltip" v-if="tooltip">
                    <i class="fas fa-question-circle"></i> {{$t('composants.sav-input.en_savoir_plus')}}
                </span>
            </div>
        </div>

        <!-- Textarea -->
        <div v-if="type == 'textarea'">
            <label
            v-show="displayLabel"
            :for="labelToId"
            class="block pb-2"
            :class="(errors && errors.length > 0 ? 'font-bold text-red-600' : 'font-light text-gray-600')"
            v-html="label"
            ></label>
            <div class="flex items-center">
                <textarea
                :test-id="testIdValue"
                class="bg-gray-50 text-gray-900 text-sm rounded-lg focus:ring-gray-400 focus:border-gray-400 block w-full p-2.5"
                :class="classSrc + ' ' + (errors && errors.length > 0 ? 'border-2 border-red-500' : 'border border-gray-300')"
                :id="labelToId"
                :placeholder="placeholder"
                v-model="inputValue"
                :disabled="disabled"
                rows="5"
                ></textarea>
                <span class="text-xs text-gray-700 cursor-pointer hover:text-gray-800" v-title="tooltip" v-if="tooltip">
                    <i class="fas fa-question-circle"></i> {{$t('composants.sav-input.en_savoir_plus')}}
                </span>
            </div>
            <small v-if="modalHelper" @click="modalHelper(meta)" class="text-blue-600 block text-xs font-light hover:underline mt-2 cursor-pointer">
                <i class="fas fa-circle-question"></i> {{$t('composants.sav-input.ou_trouver_cette_information_?')}}
            </small>
        </div>

        <!-- Date -->
        <div v-if="type == 'date'">
            <label
            v-show="displayLabel"
            :for="labelToId"
            class="block pb-2"
            :class="(errors && errors.length > 0 ? 'font-bold text-red-600' : 'font-light text-gray-600')"
            v-html="label"
            ></label>
            <div class="flex items-center">
                <!-- <input
                type="date"
                class="bg-gray-50 text-gray-900 text-sm rounded-lg focus:ring-gray-400 focus:border-gray-400 block w-full p-2.5"
                :class="classSrc + ' ' + (errors && errors.length > 0 ? 'border-2 border-red-500' : 'border border-gray-300')"
                :id="labelToId"
                :placeholder="placeholder"
                :max="max"
                :min="min"
                v-model="inputValue"
                :disabled="disabled"
                onfocus="this.showPicker()"
                onkeydown="return false"
                > -->

                <date-picker
                v-model="inputValue"
                type="date"
                style="width: 100% !important"
                lang="fr"
                input-class="input-date bg-gray-50 text-gray-900 text-sm rounded-lg focus:ring-gray-400 focus:border-gray-400 block w-full p-2.5"
                :class="classSrc + ' ' + (errors && errors.length > 0 ? 'border-2 border-red-500' : 'border border-gray-300')"
                format="DD/MM/YYYY"
                :disabled-date="disabledDate"
                :editable="false"
                value-type="DD/MM/YYYY"
                :placeholder="placeholder"
                :disabled="disabled"
                />
                <div>
                </div>
                <span class="text-xs text-gray-700 cursor-pointer hover:text-gray-800" v-title="tooltip" v-if="tooltip">
                    <i class="fas fa-question-circle"></i> {{$t('composants.sav-input.en_savoir_plus')}}
                </span>
            </div>
            <small v-if="modalHelper" @click="modalHelper(meta)" class="text-blue-600 block text-xs font-light hover:underline mt-2 cursor-pointer">
                <i class="fas fa-circle-question"></i> {{$t('composants.sav-input.ou_trouver_cette_information_?')}}
            </small>
        </div>

        <!-- Hour -->
        <div v-if="type == 'time'">
            <label
            v-show="displayLabel"
            :for="labelToId"
            class="block pb-2"
            :class="(errors && errors.length > 0 ? 'font-bold text-red-600' : 'font-light text-gray-600')"
            v-html="label"
            ></label>
            <div class="flex items-center">
                <input
                :test-id="testIdValue"
                type="time"
                class="bg-gray-50 text-gray-900 text-sm rounded-lg focus:ring-gray-400 focus:border-gray-400 block w-full p-2.5"
                :class="classSrc + ' ' + (errors && errors.length > 0 ? 'border-2 border-red-500' : 'border border-gray-300')"
                :id="labelToId"
                :placeholder="placeholder"
                v-model="inputValue"
                :disabled="disabled"
                >
                <span class="text-xs text-gray-700 cursor-pointer hover:text-gray-800" v-title="tooltip" v-if="tooltip">
                    <i class="fas fa-question-circle"></i> {{$t('composants.sav-input.en_savoir_plus')}}
                </span>
            </div>
            <small v-if="modalHelper" @click="modalHelper(meta)" class="text-blue-600 block text-xs font-light hover:underline mt-2 cursor-pointer">
                <i class="fas fa-circle-question"></i> {{$t('composants.sav-input.ou_trouver_cette_information_?')}}
            </small>
        </div>

        <!-- Date Local -->
        <div v-if="type == 'date-local'">
            <label
            v-show="displayLabel"
            :for="labelToId"
            class="block pb-2"
            :class="(errors && errors.length > 0 ? 'font-bold text-red-600' : 'font-light text-gray-600')"
            v-html="label"
            ></label>
            <div class="flex items-center">
                <input
                :test-id="testIdValue"
                type="datetime-local"
                class="bg-gray-50 text-gray-900 text-sm rounded-lg focus:ring-gray-400 focus:border-gray-400 block w-full p-2.5"
                :class="classSrc + ' ' + (errors && errors.length > 0 ? 'border-2 border-red-500' : 'border border-gray-300')"
                :id="labelToId"
                :placeholder="placeholder"
                v-model="inputValue"
                :disabled="disabled"
                >
                <span class="text-xs text-gray-700 cursor-pointer hover:text-gray-800" v-title="tooltip" v-if="tooltip">
                    <i class="fas fa-question-circle"></i> {{$t('composants.sav-input.en_savoir_plus')}}
                </span>
            </div>
            <small v-if="modalHelper" @click="modalHelper(meta)" class="text-blue-600 block text-xs font-light hover:underline mt-2 cursor-pointer">
                <i class="fas fa-circle-question"></i> {{$t('composants.sav-input.ou_trouver_cette_information_?')}}
            </small>
        </div>

        <!-- Tel -->
        <div v-if="type == 'tel'">
            <label
            v-show="displayLabel"
            :for="labelToId"
            class="block pb-2"
            :class="(errors && errors.length > 0 ? 'font-bold text-red-600' : 'font-light text-gray-600')"
            v-html="label"></label>
            <div class="flex items-center">
                <!-- <input
                type="text"
                class="bg-gray-50 text-gray-900 text-sm rounded-lg focus:ring-gray-400 focus:border-gray-400 block w-full p-2.5"
                :class="classSrc + ' ' + (errors && errors.length > 0 ? 'border-2 border-red-500' : 'border border-gray-300')"
                :id="labelToId"
                :placeholder="placeholder"
                v-model="inputValue"
                :disabled="disabled"
                /> -->

                <vue-phone-number-input
                v-model="telData"
                @update="telValidation"
                class="w-full"
                test-id="input-tel"
                :translations="{
                    countrySelectorLabel: this.$t('composants.sav-input.code_pays'),
                    countrySelectorError: this.$t('composants.sav-input.choisir_un_pays'),
                    phoneNumberLabel: this.$t('composants.sav-input.numero_de_telephone'),
                    example: this.$t('composants.sav-input.exemple')
                }"
                ></vue-phone-number-input>

                <span class="text-xs text-gray-700 cursor-pointer hover:text-gray-800" v-title="tooltip" v-if="tooltip">
                    <i class="fas fa-question-circle"></i> {{$t('composants.sav-input.en_savoir_plus')}}
                </span>
            </div>
            <small v-if="modalHelper" @click="modalHelper(meta)" class="text-blue-600 block text-xs font-light hover:underline mt-2 cursor-pointer">
                <i class="fas fa-circle-question"></i> {{$t('composants.sav-input.ou_trouver_cette_information_?')}}
            </small>
        </div>

        <!-- Select -->
        <div v-if="type == 'select'">
            <label
            v-show="displayLabel"
            :for="labelToId"
            class="block pb-2"
            :class="(errors && errors.length > 0 ? 'font-bold text-red-600' : 'font-light text-gray-600')"
            v-html="label"
            ></label>
            <div class="flex items-center">
                <select
                :test-id="testIdValue"
                class="bg-gray-50 text-gray-900 text-sm rounded-lg focus:ring-gray-400 focus:border-gray-400 block w-full p-2.5"
                :class="classSrc + ' ' + (errors && errors.length > 0 ? 'border-2 border-red-500' : 'border border-gray-300')"
                :id="labelToId"
                :placeholder="placeholder"
                v-model="inputValue"
                :disabled="disabled"
                @change="callbackOnChange"
                >
                    <option v-for="(option, index) in options.values" :value="options.key ? option[options.key] : option" :key="index">
                        {{ option[options.label] }}
                    </option>
                </select>
                <span class="text-xs text-gray-700 cursor-pointer hover:text-gray-800" v-title="tooltip" v-if="tooltip">
                    <i class="fas fa-question-circle"></i> {{$t('composants.sav-input.en_savoir_plus')}}
                </span>
            </div>
            <small v-if="modalHelper" @click="modalHelper(meta)" class="text-blue-600 block text-xs font-light hover:underline mt-2 cursor-pointer">
                <i class="fas fa-circle-question"></i> {{$t('composants.sav-input.ou_trouver_cette_information_?')}}
            </small>
        </div>

        <!-- VueSelect -->
        <div v-if="type == 'vue-select'">
            <label v-show="displayLabel" :for="labelToId" class="block pb-2 font-light text-gray-600" v-html="label"></label>

            <div class="flex items-center">
                <multiselect
                v-if="options.values"
                :class="classSrc + ' ' + (errors && errors.length > 0 ? 'border-2 border-red-500' : 'border border-gray-300')"
                :id="labelToId"
                v-model="inputValue"
                :track-by="options.label"
                :label="options.label"
                :placeholder="placeholder"
                :options="options.values"
                selectLabel=""
                selectedLabel=""
                deselectLabel=""
                :disabled="disabled"
                >
                    <template v-slot:noOptions>
                        Aucun élément
                    </template>
                </multiselect>
                <span class="text-xs text-gray-700 cursor-pointer hover:text-gray-800" v-title="tooltip" v-if="tooltip">
                    <i class="fas fa-question-circle"></i> {{$t('composants.sav-input.en_savoir_plus')}}
                </span>
            </div>
            <small v-if="modalHelper" @click="modalHelper(meta)" class="text-blue-600 block text-xs font-light hover:underline mt-2 cursor-pointer">
                <i class="fas fa-circle-question"></i> {{$t('composants.sav-input.ou_trouver_cette_information_?')}}
            </small>
        </div>

        <!-- Sav Select -->
        <div v-if="type == 'sav-select'">
            <sav-select-input
            :class-src="classSrc"
            v-model="inputValue"
            :disabled="disabled"
            :options="options"
            />
            <small v-if="modalHelper" @click="modalHelper(meta)" class="text-blue-600 block text-xs font-light hover:underline mt-2 cursor-pointer">
                <i class="fas fa-circle-question"></i> {{$t('composants.sav-input.ou_trouver_cette_information_?')}}
            </small>
        </div>

        <!-- File -->
        <div v-if="type == 'file'">
            <label v-show="displayLabel" :for="labelToId" class="block pb-2 font-light text-gray-600" v-html="label"></label>
            <div class="flex items-center">
                <sav-input-file-upload
                :label="label"
                :class-src="classSrc"
                :placeholder="placeholder"
                :disabled="disabled"
                v-model="inputValue"
                :default-data="value"
                :take-photo="options ? options.take_photo : 1"
                :camera="options ? options.camera : 0"
                class="w-full"
                />
            </div>
            <small v-if="modalHelper" @click="modalHelper(meta)" class="text-blue-600 block text-xs font-light hover:underline mt-2 cursor-pointer">
                <i class="fas fa-circle-question"></i> {{$t('composants.sav-input.ou_trouver_cette_information_?')}}
            </small>
        </div>

        <!-- Date fabrication -->
        <div v-if="type == 'date-fabrication'">
            <label v-show="displayLabel" :for="labelToId" class="block pb-2 font-light text-gray-600" v-html="label"></label>
            <div class="flex items-center">
                <sav-input-date-fabrication
                :label="label"
                :class-src="classSrc"
                :placeholder="placeholder"
                :disabled="disabled"
                v-model="inputValue"
                :default-data="value"
                class="w-full"
                />
            </div>
            <small v-if="modalHelper" @click="modalHelper(meta)" class="text-blue-600 block text-xs font-light hover:underline mt-2 cursor-pointer">
                <i class="fas fa-circle-question"></i> {{$t('composants.sav-input.ou_trouver_cette_information_?')}}
            </small>
        </div>

        <!-- Indice Sav -->
        <div v-if="type == 'indice-sav'">
            <label v-show="displayLabel" :for="labelToId" class="block pb-2 font-light text-gray-600" v-html="label"></label>
            <div class="flex items-center">
                <sav-input-indice-sav
                :label="label"
                :class-src="classSrc"
                :placeholder="placeholder"
                :disabled="disabled"
                v-model="inputValue"
                :default-data="value"
                class="w-full"
                />
            </div>
            <small v-if="modalHelper" @click="modalHelper(meta)" class="text-blue-600 block text-xs font-light hover:underline mt-2 cursor-pointer">
                <i class="fas fa-circle-question"></i> {{$t('composants.sav-input.ou_trouver_cette_information_?')}}
            </small>
        </div>

        <!-- Camera -->
        <div v-if="type == 'capture'">
            <label
            v-show="displayLabel"
            :for="labelToId"
            class="block pb-2"
            :class="(errors && errors.length > 0 ? 'font-bold text-red-600' : 'font-light text-gray-600')"
            v-html="label"></label>
            <div class="flex items-center">
                <sav-image-input @input="emitCompressedFile" />
                <span class="text-xs text-gray-700 cursor-pointer hover:text-gray-800" v-title="tooltip" v-if="tooltip">
                    <i class="fas fa-question-circle"></i> {{$t('composants.sav-input.en_savoir_plus')}}
                </span>
            </div>
            <small v-if="modalHelper" @click="modalHelper(meta)" class="text-blue-600 block text-xs font-light hover:underline mt-2 cursor-pointer">
                <i class="fas fa-circle-question"></i> {{$t('composants.sav-input.ou_trouver_cette_information_?')}}
            </small>
        </div>

        <!-- Errors -->
        <div>
            <ul class="mb-0" :class="errors && errors.length > 1 ? 'ml-4' : ''">
                <li
                v-for="(error, index) in errors" :key="index"
                class="mt-2 text-xs font-light text-red-500"
                :class="errors.length > 1 ? 'list-disc' : ''"
                >
                    {{ error }}
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import SavImageInput from '@/components/SavImageInput'
import SavInputFileUpload from '@/components/SavInputFileUpload'
import SavSelectInput from '@/components/SavSelectInput.vue'
import SavInputDateFabrication from '@/components/SavInputDateFabrication.vue'
import SavInputIndiceSav from '@/components/SavInputIndiceSav.vue'

import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/fr';

export default {
    props: {
        label: {
            type: String,
        },
        type: {
            type: String,
            required: true
        },
        classSrc: {
            type: String
        },
        options: {
            type: Object
        },
        value: {},
        placeholder: {
            type: String
        },
        tooltip: {
            type: String,
        },
        errors: {
            type: Array
        },
        disabled: {
            type: Boolean,
            default: false
        },
        min: {
            type: String
        },
        max: {
            type: String
        },
        displayLabel: {
            type: Boolean,
            default: true
        },
        onChange: {},
        testIdValue: {},
        meta: {},
        modalHelper: {},
        maxlength: {}
    },

    watch: {
        value: function(value) {
            this.inputValue = value
        },

        inputValue: function(value) {
            this.emitData()
        }
    },

    components: {
        Multiselect,
        SavImageInput,
        SavInputFileUpload,
        SavSelectInput,
        DatePicker,
        SavInputDateFabrication,
        SavInputIndiceSav
    },

    computed: {
        labelToId: function() {
            if (this.label) {
                return this.label.replace(/[.,\/#!$%\^&\*;:{}=\-_`~()]/g,"").replace(/\s/g, '-').normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase()
            }
        }
    },

    data() {
        return {
            inputValue: null,
            previewUrl: null,
            displayPassword: false,
            telData: "",
        }
    },

    methods: {
        emitData() {
            this.$emit('input', this.inputValue)
        },
        emitFile: function(event) {
            this.inputValue = event.target.files[0]

        },
        emitCompressedFile: function(event) {
            this.inputValue = event
        },

        telValidation: function(value) {
            if (value.isValid) {
                this.inputValue = value.formatNational
            } else {
                this.$emit('input', null)
            }
        },

        disabledDate(date) {
            let endValue = false
            if (this.meta && this.meta.disabledDays) {
                const day = new Date(date).getDay()
                endValue = this.meta.disabledDays.includes(day)
            }
            if (!endValue && this.min && this.max) {
                return !((date > new Date(this.min)) && (date < new Date(this.max)))
            } else if (!endValue && this.min && !this.max) {
                return !(date > new Date(this.min))
            } else if (!endValue && !this.min && this.max) {
                return !(date < new Date(this.max))
            }
            return true
        },

        callbackOnChange(data) {
            if (this.onChange) {
                this.onChange(data)
            }
        }
    },

    mounted() {
        this.inputValue = this.value

        if (this.type == 'tel') {
            this.$nextTick(() => {
                this.telData = this.value
                if (this.value) {
                    this.emitData()
                }
            })
        }
    }
}
</script>

<style>
.vue-phone-number-input .input-tel__input, .vue-phone-number-input .country-selector__input {
    background: #f9fafb !important;
}

.input-tel__label {
    display: none !important;
}
.input-tel__input {
    padding-top: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/SavInput.vue